import { render, staticRenderFns } from "./MoveCommercialEntitiesModal.vue?vue&type=template&id=4f22039e&"
import script from "./MoveCommercialEntitiesModal.vue?vue&type=script&lang=js&"
export * from "./MoveCommercialEntitiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports